import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { HelmetProvider } from 'react-helmet-async';
import theme from './theme/theme';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import RegisterSuccessPage from './pages/RegisterSuccessPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import VerificationRequestPage from './pages/VerificationRequestPage';
import FindTalentPage from './pages/FindTalentPage';
import FindWorkPage from './pages/FindWorkPage';
import ProjectDetailsPage from './pages/ProjectDetailsPage';
import NewProjectPage from './pages/NewProjectPage';
import NewServicePage from './pages/NewServicePage';
import FindServicesPage from './pages/FindServicesPage';
import ServiceDetailsPage from './pages/ServiceDetailsPage';
import CreditPurchasePage from './pages/CreditPurchasePage';
import CreditHistoryPage from './pages/CreditHistoryPage';
import ProfilePage from './pages/ProfilePage';
import AdminDashboard from './pages/AdminDashboard';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminAuthGuard from './components/AdminAuthGuard';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import FAQPage from './pages/FAQPage';
import CookiesPage from './pages/CookiesPage';
import StatusPage from './pages/StatusPage';
import NotificationsPage from './pages/NotificationsPage';
import { CreditProvider } from './contexts/CreditContext';
import { StripeProvider } from './contexts/StripeContext';
import { NotificationProvider } from './contexts/NotificationContext';
import GoogleAnalytics from './components/GoogleAnalytics';
import './i18n';
import './index.css';

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <StripeProvider>
          <CreditProvider>
            <NotificationProvider>
              <Router>
                <GoogleAnalytics />
            <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/register-success" element={<RegisterSuccessPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/verification" element={<VerificationRequestPage />} />
            <Route path="/find-talent" element={<FindTalentPage />} />
            <Route path="/find-work" element={<FindWorkPage />} />
            <Route path="/project/:id" element={<ProjectDetailsPage />} />
            <Route path="/find-services" element={<FindServicesPage />} />
            <Route path="/service/:id" element={<ServiceDetailsPage />} />
            <Route path="/new-project" element={<NewProjectPage />} />
            <Route path="/new-service" element={<NewServicePage />} />
            <Route path="/freelancer/:id" element={<ProfilePage />} />
            <Route path="/freelancer/:id/edit" element={<ProfilePage />} />
            <Route path="/credits" element={<CreditPurchasePage />} />
            <Route path="/credits/history" element={<CreditHistoryPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/cookies" element={<CookiesPage />} />
            <Route path="/status" element={<StatusPage />} />
            <Route path="/notifications" element={<NotificationsPage />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={
              <AdminAuthGuard>
                <AdminDashboard />
              </AdminAuthGuard>
            } />
          </Routes>
              </Router>
            </NotificationProvider>
          </CreditProvider>
        </StripeProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;